<template>
  <div class="PHONE_BAR_box-kjafg782147">
    <div
      :class="['phone-bar-kjafg782147', 'light-theme']"
      id="PHONE_BAR"
      v-outside="() => this.handleOutside('#PHONE_BAR .select_group', 2)"
      @mousedown="handlePhoneBarClick"
    >
    </div>
    <div class="right-area" v-if="isPhoneBarInit">
      <div
        :title="$t('qidian.expand')"
        class="action_btn"
        v-show="!qidianExpand"
        @click="setQidianExpand(true)"
      ><i class="iconfont icon-shuangyou-line"></i></div>
      <div
        :title="$t('qidian.collapse')"
        class="action_btn"
        v-show="qidianExpand"
        @click="setQidianExpand(false)"
      ><i class="iconfont icon-shuangzuo-line"></i></div>
    </div>
  </div>
</template>

<script>
import mixins from "@/mixins";
import qidianMixin from '@/mixins/qidian'
import { sendQdMsg } from '@/utils/qidian'
import { mapActions, mapState } from 'vuex';

function debounce(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

const defaultWidth = 900 + 20
const collapseWidth = 170

export default {
  mixins: [mixins, qidianMixin],
  data() {
    return {
      floatPageStyle: {
        width: defaultWidth,
        height: 50,
      },
      autoHeightObj: null,
      containerObserver: null,
      isClient: false, // 是否是企点客户端
      isPhoneBarInit: false, // 电话条是否初始化
    }
  },
  computed: {
    ...mapState(['qidianExpand']),
  },
  watch: {
    qidianExpand: {
      handler() {
        this.handleQidianExpand()
      },
      immediate: true
    }
  },
  created() {
    if(this.$route.query.scene === 'client') {
      this.isClient = true;
      // 给body加一个类名
      document.body.classList.add('qidian-client-body');
      // 创建企点客户端通信通道
      window.qidianClientChannel = new BroadcastChannel('qidian-client-channel');
      window.qidianClientChannel.addEventListener('message', event => {
        this.postMsgListener(event)
      });
    }
  },
  mounted() {
    sendQdMsg({
      type: 'ExtApp.FloatPage', // 注意顶部菜单传入的type与浮窗内传入的type需要严格区别
      method: 'setFloatPageStyle',
      payload: { height: 50, width: defaultWidth }
    }, '*');
    const root = document.getElementById('app-content')
    this.autoHeightObj = this.createAutoHeight(root);
    // 添加对 PHONE_BAR 的监听
    this.startContainerMonitoring();
  },
  methods: {
    ...mapActions(['setQidianExpand']),
    handleQidianExpand() {
      if(this.qidianExpand) {
        const bar = document.querySelector('#cti_phone_bar_container')
        if(bar) {
          bar.classList.remove('qidian-collapse-phone-bar')
          bar.classList.add('qidian-hide-phone-bar')
          setTimeout(() => {
            bar.classList.remove('qidian-hide-phone-bar')
          }, 200)
        }
        if(this.autoHeightObj) {
          this.autoHeightObj.adjustHeight()
        }
      } else {
        const bar = document.querySelector('#cti_phone_bar_container')
        bar && (bar.classList.add('qidian-collapse-phone-bar'))
        sendQdMsg({
          type: 'ExtApp.FloatPage', // 注意顶部菜单传入的type与浮窗内传入的type需要严格区别
          method: 'setFloatPageStyle',
          payload: { height: 50, width: collapseWidth }
        }, '*');
      }
    },
    startContainerMonitoring() {
      const phoneBar = document.getElementById('PHONE_BAR');
      if (!phoneBar) return;

      // 初始检查
      this.checkForContainer();

      // 使用 MutationObserver 监听变化
      this.containerObserver = new MutationObserver(() => {
        this.checkForContainer();
      });

      this.containerObserver.observe(phoneBar, {
        childList: true,
        subtree: true
      });
    },
    checkForContainer() {
      const phoneBar = document.getElementById('PHONE_BAR');
      const container = phoneBar && phoneBar.querySelector('#cti_phone_bar_container');
      if (container) {
        this.onContainerFound();
        this.handleQidianExpand()
      }
    },

    onContainerFound() {
      // 执行响应动作
      console.log('cti_phone_bar_container 已找到');
      this.isPhoneBarInit = true;
      // 移除监听器（如果只需要执行一次）
      this.stopContainerMonitoring();
    },

    stopContainerMonitoring() {
      if (this.containerObserver) {
        this.containerObserver.disconnect();
      }
    },
    createAutoHeight(element) {
      let isAdjusting = false;

      // 核心调整函数
      const adjustHeight = () => {
        if (isAdjusting) return;

        // 解除高度限制以获取实际内容高度
        element.style.height = 'auto';
        let contentHeight = element.scrollHeight;
        let contentWidth = 900;

        isAdjusting = true;
        ['.trans_phone_table_box'].forEach(selector => {
          const ele = document.querySelector(selector)
          if (ele && ele.style.display == 'block') {
            contentHeight = 358
          }
        });
        ['.raise_hand_table_box', '.setting_table_box'].forEach(selector => {
          const ele = document.querySelector(selector)
          if (ele && ele.style.display == 'block') {
            contentHeight = 450
          }
        });
        ['.auto_call_box'].forEach(selector => {
          const ele = document.querySelector(selector)
          if (ele && ele.style.display !== 'none') {
            contentWidth += 180
          }
        });
        ['.auto_ans_box'].forEach(selector => {
          const ele = document.querySelector(selector)
          if (ele && ele.style.display !== 'none') {
            contentWidth += 120
          }
        });

        element.style.height = `${contentHeight}px`;
        if(this.floatPageStyle.height !== contentHeight || this.floatPageStyle.width !== contentWidth) {
          this.floatPageStyle.height = contentHeight;
          this.floatPageStyle.width = contentWidth;
          sendQdMsg({
            type: 'ExtApp.FloatPage', // 注意顶部菜单传入的type与浮窗内传入的type需要严格区别
            method: 'setFloatPageStyle',
            payload: { height: contentHeight === 50 ? contentHeight : (contentHeight + 6), width: this.qidianExpand ? (contentWidth + 20) : collapseWidth }
          }, '*');
        }

        isAdjusting = false;
      };

      const debouncedAdjust = debounce(adjustHeight, 150);

      // 创建观察器
      const mutationObserver = new MutationObserver((mutations) => {
        if (!isAdjusting) {
          requestAnimationFrame(debouncedAdjust);
        }
      });

      const resizeObserver = new ResizeObserver(() => {
        if (!isAdjusting) {
          requestAnimationFrame(debouncedAdjust);
        }
      });

      // 初始化设置
      mutationObserver.observe(element, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      resizeObserver.observe(element);
      adjustHeight(); // 初始调整

      return {
        destroy: () => {
          mutationObserver.disconnect();
          resizeObserver.disconnect();
        },
        adjustHeight: adjustHeight
      };
    },
    handlePhoneBarClick(event) {
      if(this.isClient) {
        // 判断点击的是否是PhoneBar本身而非子元素
        const phoneBarBox = document.querySelector('#PHONE_BAR #cti_phone_bar_container');
        if (event.target === event.currentTarget || (phoneBarBox && event.target === phoneBarBox)) {
          // 执行点击PhoneBar本身时的逻辑
          window.external.invoke("viewInterface.dragMove", "{}", "callback_key");
        }
      }
    }
  },
  beforeDestroy() {
    if(this.autoHeightObj) {
      this.autoHeightObj.destroy()
    }
    if(window.qidianClientChannel) {
      window.qidianClientChannel.close();
    }
    this.stopContainerMonitoring(); // 停止监听
  },
}
</script>
<style lang="less">
body:has(.phone-bar-kjafg782147) {
  #app-content {
    overflow: unset!important;
  }
  .phone-bar-kjafg782147 {
    background: #f5f7fc;
    border-radius: 6px;
  }
  .errorTips {
    display: none;
  }
  .detect-device-container {
    display: none!important;
  }
}
.qidian-client-body {
  // #app-content {
  //   /* 隐藏垂直滚动条 */
  //   &::-webkit-scrollbar {
  //     width: 0;
  //   }
  //   /* 隐藏水平滚动条 */
  //   &::-webkit-scrollbar {
  //     height: 0;
  //   }
  // }
  #app-content {
    overflow: unset!important;
  }
  .phone-bar-kjafg782147 {
    background: #f5f7fc;
    outline: none;
    border-radius: 6px;
    & > div {
      outline: none;
    }
  }
  .errorTips {
    display: none;
  }
  .detect-device-container {
    display: none!important;
  }
  #cti_phone_bar_container {
    outline: none;
    &:hover {
      cursor: move;
    }
    & > * {
      cursor: default;
    }
    .phone_status_box {
      &:hover {
        cursor: pointer;
      }
    }
  }
}
#PHONE_BAR {
  &.phone-bar-kjafg782147 {
    width: 100%;
    float: unset;
    #cti_phone_bar_container {
      background: none !important;

      .call_num_input {
        background: #EDF1F6;
        color: #323233;
      }

      .dialplate_box {
        .icon {
          color: #323233;
        }
      }

      .status_inner {
        // background: #b4b5b8 !important;
        color: #fff;

        .icsoc_icon-triangle-down {
          color: #fff !important;
        }
      }

      .action_btn {
        background: #4a70ff !important;
        margin-left: 8px;
        &.red_action_btn {
          background: #ff5b57 !important;
        }
      }

      .select_box:not(.phone_status_box) {
        background: #EDF1F6;
        color: #323233;

        .icsoc_icon-triangle-down {
          color: rgba(50, 50, 51, 0.6);
        }

        // .selected_value {
        //   &:hover+
        // }
      }

      .selected_hover_box {
        display: none !important;
      }

      .left_box .called_box .status-info {
        color: #323233;
      }
      .message_box {
        position: relative;
        z-index: 100000;
        clear: both;
        top: 0;
      }
      .phone_answer_box {
        position: relative;
        z-index: 1000000;
        clear: both;
        inset: 0 0 0 0!important;
        // inset: 50px auto auto 357px;
      }

      .left_box .rtccheck {
        display: none!important;
      }

      // 设置悬浮框
      .setting_table_box {
        transform: translate(-10px);
      }

      // 排队dialog
      .queueDig {
        transform: translate(-20px);
      }

      // 隐藏浮窗背景
      .trans_phone_table_box_bg, .raise_hand_table_box_bg {
        background-color: transparent;
      }
    }
    #cti_phone_bar_container .left_box .phone_status_box .status_inner.green {
      background: #00d48a!important;
    }
    // // 隐藏
    // #cti_phone_bar_container .left_box .trans_phone_box,
    // #cti_phone_bar_container .left_box .auto_call_box,
    // #cti_phone_bar_container .left_box .phone_actions.phone_actions_last,
    // #cti_phone_bar_container .left_box .raise_hand_line,
    // #cti_phone_bar_container .left_box .setting_btn_box,
    // #cti_phone_bar_container .left_box .rtccheck
    // {
    //   display: none!important;
    // }

    #cti_phone_bar_container .left_box .raise_hand_line .raise_hand_details_btn .raise_hand_form {
      position: relative;
      float: right;
      .box_arrow {
        display: none;
      }
    }

    // 收起电话条样式
    #cti_phone_bar_container.qidian-collapse-phone-bar {
      & > * {
        display: none!important;
      }
      & > .left_box {
        display: block!important;
      }
      & > .left_box > * {
        display: none!important;
      }
      & > .left_box > .phone_status_box {
        display: block!important;
        .busy_select_group {
          width: 146px;
        }
      }
    }
    #cti_phone_bar_container.qidian-hide-phone-bar {
      & > * {
        opacity: 0!important;
      }
      & > .left_box {
        opacity: 1!important;
      }
      & > .left_box > * {
        opacity: 0!important;
      }
      & > .left_box > .phone_status_box {
        opacity: 1!important;
      }
    }
  }
}
.PHONE_BAR_box-kjafg782147 {
  position: relative;
  // 右侧自定义区域
  .right-area {
    top: 0px;
    right: 0px;
    position: absolute;
    margin: 9px 9px 9px 9px;
    .action_btn {
      // 38px
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 32px;
      color: #323233;
      border-radius: 6px;
      cursor: pointer;
      background: #EDF1F6;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/QiDian/PhoneBar.vue